//export const BASE_URL = process.env.BASE_URL || 'https://';
export const BASE_URL = 'https://neurokratos.space';